import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "@phosphor-icons/react";
import { loadGA } from "@/components/Analytics";

const KEY = "orbit_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch { /* ignore */ }
  }, []);

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
    if (value === "all") loadGA();
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto rounded-xl border border-zinc-200 bg-white shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={22} weight="fill" className="text-emerald-600 shrink-0 mt-0.5" />
          <p className="text-sm text-zinc-600 leading-relaxed">
            We use essential cookies to run this site and keep you signed in. With your consent we may also use analytics to improve the product. See our{" "}
            <Link to="/privacy" className="text-emerald-700 font-medium hover:underline">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" className="h-10 border-zinc-300 font-semibold" onClick={() => choose("essential")} data-testid="cookie-decline">Essential only</Button>
          <Button className="h-10 bg-zinc-950 hover:bg-zinc-800 text-white font-semibold" onClick={() => choose("all")} data-testid="cookie-accept">Accept all</Button>
        </div>
      </div>
    </div>
  );
}
